














































import { Component, Vue } from 'vue-property-decorator';

import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';

import { uuid } from 'vue-uuid';

import {ITag} from '../shared/services/models/Interface';

// The @Component decorator indicates the class is a Vue component
@Component({
    components: {
        // @ts-ignore
        CopyrightComponent : require('@/components/Copyright').default,
    },
    computed: {
        ...mapState(['tags']),
    },
    methods: {
        ...mapActions(['addTag', 'updateTag', 'deleteTag', 'updateTags']),
    },
})
export default class TagsComponent extends Vue {
    private tags!: ITag[];
    private updateHandle: number = 0;
    private tagName: string = '';

    private mounted() {
        // @ts-ignore
        this.updateTags();
    }

    private get Tags(): ITag[] {
        return this.tags;
    }

    private async save(tag: ITag) {
        // console.log('allowBlockList', allowBlockList);
        // @ts-ignore
        this.updateTag(tag);
        // @ts-ignore
        this.updateTags();
    }

    private remove(tag: ITag) {
        // @ts-ignore
        this.deleteTag(tag);
        // @ts-ignore
        this.updateTags();
    }
    private add() {
        this.$bvModal.show('modal-add-tag');
    }
    private addTagSave() {
        // console.log('allowBlockList', allowBlockList);
        // @ts-ignore
        this.addTag({ id: uuid.v4(),  name: this.tagName});
        setTimeout(()  => {
            // @ts-ignore
            this.updateTags();
        }, 1000);
    }

    private destroyed() {
          //  clearInterval(this.updateHandle);
    }
}
